import cx from 'classnames';
import { MouseEvent } from 'react';

export type BreadcrumbItem = {
    text: string;
    url: string;
    dataTestId?: string;
};

export type BreadcrumbProps = {
    items: BreadcrumbItem[];
    onClickItem?: (event: MouseEvent, item: BreadcrumbItem) => void;
    reversed?: boolean;
    className?: string;
};

import style from './Breadcrumb.module.css';

export function Breadcrumb({ items, onClickItem, reversed = false, className }: BreadcrumbProps) {
    return (
        <ol
            itemScope
            itemType="https://schema.org/BreadcrumbList"
            className={cx(style.breadcrumb, className, {
                [style.reversed]: reversed,
            })}
            data-testid="Breadcrumb"
        >
            {items.map((item, key) => {
                return (
                    <li
                        className={cx(style.item, 'font-xs-regular')}
                        itemProp="itemListElement"
                        itemScope
                        itemType="https://schema.org/ListItem"
                        key={item.text}
                        data-testid={item.dataTestId}
                    >
                        <a
                            itemType="https://schema.org/Thing"
                            itemProp="item"
                            href={item.url}
                            onClick={(event) => {
                                if (typeof onClickItem === 'function') {
                                    onClickItem(event, item);
                                }
                            }}
                        >
                            <span className={style.itemText} itemProp="name">
                                {item.text}
                            </span>
                        </a>
                        <meta itemProp="position" content={`${key + 1}`}></meta>
                    </li>
                );
            })}
        </ol>
    );
}
